export default "__VITE_ASSET__BcA_Hpox__"